import iconPoint from '../../images/point.svg'
import iconPointCar from '../../images/point-car.svg'
import {break_sm_up} from "../../js/constants";
import {loadScript} from "../../js/helpers";

const contactMap = document.getElementById('contactMap')

if (contactMap) {
  loadScript("https://api-maps.yandex.ru/2.1/?apikey=109e4b66-0503-4da1-b84c-bc91501ea5fa&lang=ru_RU", map)
}

const mapData = {
  icons: {
    iconPoint,
    iconPointCar
  }
};

function map() {
  if (ymaps) {
    ymaps.ready(init);
    function init(){
      // if (!contactMap) return;
      const myMap = new ymaps.Map("contactMap", {
        center: [Number(contactMap.dataset.lat), Number(contactMap.dataset.lng)],
        controls: ['zoomControl', 'geolocationControl'],
        zoom: 14
      }, {
        zoomControlSize: 'small',
        zoomControlPosition: {
          right: "20px",
        },
        geolocationControlPosition: {
          right: "20px",
          top: "70px"
        },
      });

      myMap.behaviors.disable('scrollZoom')

      const iconImageSize = [];
      const iconImageOffset = [];

      if (contactMap.dataset.iconSize) {
        const size = contactMap.dataset.iconSize.split(' ');
        iconImageSize.push(Number(size[0]), Number(size[1]));
        iconImageOffset.push(-Number(size[0])/2, -Number(size[0]));
      } else {
        if(window.innerWidth >= break_sm_up) {
          iconImageSize.push(79, 101);
          iconImageOffset.push(-79/2, -101);
        } else {
          iconImageSize.push(48, 61);
          iconImageOffset.push(-48/2, -61);
        }
      }

      const myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
      }, {
        iconLayout: 'default#image',
        iconImageHref: mapData.icons[contactMap.dataset.icon],
        iconImageSize: iconImageSize,
        iconImageOffset: iconImageOffset
      });

      myMap.geoObjects.add(myPlacemark)
    }

  }
}
